import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import { DNDTypes } from './DNDTypes';
import Window from './Window';
import './WindowedApp.css';

class WindowContainer extends Component {
	state = {
		minimized: false,
		visible: true,
	}

	funcMinimize = () => {
		//console.log("[WindowContainer] funcMinimize");
		const { index } = this.props;
		const { minimized } = this.state;
		this.props.funcResize(index, minimized);
		this.setState({
			minimized: !this.state.minimized
		});
	}

	funcClose = () => {
		//console.log("[WindowContainer] closing");
		const { index } = this.props;
		this.setState({
			visible: !this.state.visible
		});
		this.props.funcRemoveWindow(index);
	}

	funcMoveZ = () => {
		//console.log("[WindowContainer]  click move Z index"); // TODO rename and improve
		this.props.funcMoveZ(this.props.index);
	}


	funcAction = (name) => {
		this.props.funcActions(name);
	}

	render() {
		//console.log("[WindowContainer] render ", this.props);

		const { connectDragPreview, window, index, actions } = this.props;
		const { minimized } = this.state

		return connectDragPreview(
			<div className={"Window" + (minimized === true ? " fade-out" : " fade-in")} >
				<Window
					window={window}
					minimized={this.state.minimized}
					index={index}
					key={index}
					zIndex={window.zIndex}
					buttons={window.buttons}
					fieldData={window.fields}
					xLeft={window.xLeft}
					yTop={window.yTop}
					size_w={window.size_w}
					size_h={window.size_h}
					funcMinimize={this.funcMinimize}
					funcClose={this.funcClose}
					funcMoveZ={this.funcMoveZ}
					actions={actions}
					funcAction={this.funcAction}
					connectDragPreview={connectDragPreview}
				/>
			</div>
		)
	}
}


const dragSource = {
	beginDrag: function (props, monitor, component) {
		//console.log("[WindowContainer] beginDrag");
		return props
	},
	isDragging: function (props, monitor, component) {
		//console.log("[WindowContainer] dragging");
	},
	endDrag: function (props, monitor, component) {
		if (!monitor.didDrop()) {
			return;
		} else {
			//console.log("[WindowContainer] endDrag");
			//const item = monitor.getItem();
			//console.log(item);
			//const dropResult = monitor.getDropResult();
			//console.log(dropResult);

			component.setState({
				yTop: component.props.yTop + 50,
				xLeft: component.props.xLeft + 50
			})
		}
	}
}

function dragCollect(connect, monitor, component) {
	return {
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging(),
	}
}

WindowContainer = DragSource(DNDTypes.WINDOW, dragSource, dragCollect)(WindowContainer);
export default WindowContainer;


// WEBPACK FOOTER //
// ./src/components/windowed/WindowContainer.js